import React, { Component, PropTypes } from 'react';
import LoginForm from './login-form';
import { connect } from 'react-redux';
import { Title } from '../layout';
import { GenericError, LegalSection } from '../common';
import { tenantHelpers } from '../tenantInfo';
import './login.component.scss';
import ForgotPasswordComponent from '../acct/password/forgot-password.component';

/**
 * The login page a user will see prior to signing in
 */
export class LoginComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forgotPassword: false,
    }
  }

  handleForgotPasswordClick() {
    this.setState({forgotPassword: true});
  }

  handleCancelResetPasswordClick() {
    this.setState({forgotPassword: false});
  }

  renderLogo() {
    const { tenant } = this.props;
    const { currentTenant } = tenant || {};
    const tenantLogoUrl = currentTenant && currentTenant.logoUrl;
    const bypassCache = `?param=${Math.random()}`;
    const logoUrl = !!tenantLogoUrl ? tenantLogoUrl + bypassCache : null;
    const productName = tenantHelpers.getProductName();
    return logoUrl ? <img id="bonterra-logo-login" className="logo" alt={`${productName} logo`} src={logoUrl} />
      : <bonterra-logo name="bonterra_logo_horizontal" size="large" />;
  }

  render() {
    const { login, auth } = this.props;
    const { forgotPassword } = this.state;
    const { justLoggedOut } = auth || {};
    const { message : loginMessage, accessRevokedErr } = login || {};

    let topMessage = null;
    if(accessRevokedErr !== null) {
      topMessage = <GenericError err={accessRevokedErr}/>
    }
    else if ( loginMessage !== null && loginMessage !== '' && !justLoggedOut ) {
      topMessage = <div role="alert" aria-live="polite" className="alert alert-success">{loginMessage}</div>
    }
    else if (justLoggedOut) {
      topMessage = <div role="alert" aria-live="polite" className="alert alert-success">
        You have successfully logged out of {tenantHelpers.getProductName()}. You can log in again below.
      </div>
    }

    return (
      <div id="login-page">
        <Title title="Login"/>
        <div id="login-left-side">
          <div className="login-page-body">
            <div className="login-vertical-align">
              {this.renderLogo()}
              {forgotPassword ?
                <div className="login-form-container">
                  <ForgotPasswordComponent onSuccess={() => this.handleCancelResetPasswordClick()} />
                  <div className="forgot-password">
                    <button className="login-page-link" onClick={() => this.handleCancelResetPasswordClick()}>
                      Cancel
                    </button>
                  </div>
                </div>
                :
                <div className="login-form-container">
                  {topMessage}
                  <LoginForm redirect={true} />
                  <div className="forgot-password">
                    <button className="login-page-link" onClick={() => this.handleForgotPasswordClick()}>
                      Forgot My Password
                      </button>
                  </div>
                </div>
              }
            </div>
          </div>
          <LegalSection />
        </div>
        <div id="login-right-side">
          <div id="welcome-message">
            Welcome to Connect!
          </div>
          <div id="login-image-container">
            <img src="/Hero_IMG@1x.png" alt="Welcome to connect" />
          </div>
        </div>
      </div>
    );
  }
}

LoginComponent.propTypes = {
  auth: PropTypes.any.isRequired,
  login: PropTypes.any.isRequired,
  tenant: PropTypes.any.isRequired,
};

const mapStateToProps = ({ auth, login, tenant }) => {
  return {
    auth,
    login,
    tenant,
  }
}

export default connect(mapStateToProps)(LoginComponent);



// WEBPACK FOOTER //
// src/login/login.component.js